<template>
    <b-modal id="myInfoPasswordCheckModal" title="비밀번호 확인" size="md" @hidden="fn_reset">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>비밀번호</th>
                                <td class="ac"><input type="password" class="form_control" v-model="checkInfo.password" @keyup.enter="fn_password_check()"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_password_check()" class="btn btn_md btn_brown">확인</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>

    import axios from 'axios'

    export default {
        name: 'myInfoPasswordCheckModal',
        props: {
            clinicDoctorId : String
        },
        methods: {
            fn_password_check(){

                this.checkInfo.clinicDoctorId = this.clinicDoctorId;

                axios
                    .post("/api/user/mypage/chkMyPassword", this.checkInfo)
                    .then((res) => {

                        this.checkResult = res.data.checkResult;

                        this.fn_click_apply();

                    })
                    .catch((err) => console.log(err));
            },
            fn_click_apply(){
                this.$emit('callback', this.checkResult);
            },
            fn_reset(){
                this.checkInfo.password = '';
                this.checkResult = false;
            }
        },
        data () {
            return {
                checkInfo : {
                    clinicDoctorId : '',
                    password : ''
                },
                checkResult : false
            }
        }
    }
</script>

<style>

</style>